const Pathname = path =>
  path === '/'
    ? path
    : path.slice(
        path[0] === '/' ? 1 : 0,
        path[path.length - 1] === '/' ? -1 : path.length
      );

export default Pathname;
